import React, { useEffect, useRef, useState } from 'react';

function AboutSection() {
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.1 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);

    const expertiseItems = [
        { title: "Objets anciens", desc: "vaisselle, sculptures, œuvres d'art, et autres pièces rares" },
        { title: "Mobilier d'époque", desc: "commodes, buffets, tables, fauteuils et autres meubles anciens" },
        { title: "Bijoux précieux", desc: "bagues, colliers, bracelets et montres vintage" },
        { title: "Numismatique", desc: "pièces de monnaie anciennes et médailles rares" },
        { title: "Objets de collection", desc: "livres anciens, instruments de musique, jouets d'époque" }
    ];

    const services = [
        { title: "Expertise gratuite", desc: "j'évalue gratuitement vos objets, sans engagement" },
        { title: "Achat immédiat", desc: "je procède à l'achat direct avec règlement sur place" },
        { title: "Déplacement à domicile", desc: "service rapide, discret et efficace chez vous" },
        { title: "Conseils personnalisés", desc: "accompagnement pour valoriser vos biens" }
    ];

    const values = [
        { title: "Tradition et expertise", desc: "trois générations d'expérience depuis 1975" },
        { title: "Transparence", desc: "chaque étape claire et expliquée en détail" },
        { title: "Confiance", desc: "respect de vos objets et de vos attentes" },
        { title: "Évaluation précise", desc: "estimation fiable pour tous types d'objets" }
    ];

    return (
        <section className="about-section" id="about" ref={sectionRef}>
            <div className="section-container">
                <header className="hero-header">
                    <div className="hero-content">
                        <h2 className={isVisible ? 'animate-title' : ''}>
                            Antiquités Stéphane Weinrich
                        </h2>
                        <p className="hero-subtitle">
                            Expert en Objets Anciens, Bijoux et Mobilier d'Époque
                        </p>
                    </div>
                </header>

                <div className="content-grid">
                    <div className="main-content">
                        <div className="intro-card">
                            <p className="intro-text">
                                <strong>Bienvenue chez Stéphane Weinrich</strong>, antiquaire passionné et expérimenté, spécialisé dans l'achat, la vente et l'expertise d'objets anciens.
                            </p>
                            <p>
                                Je suis <strong>Stéphane Weinrich</strong>, antiquaire de métier, et je perpétue avec fierté une tradition familiale qui s'étend sur trois générations. Depuis 1975, grâce à l'impulsion de mon grand-père, je me consacre avec passion à l'univers des antiquités.
                            </p>
                        </div>

                        <div className="section-block">
                            <h2>Une Expertise Inégalée</h2>
                            <div className="cards-grid">
                                {expertiseItems.map((item, index) => (
                                    <div key={index} className="feature-card expertise-card">
                                        <h3>{item.title}</h3>
                                        <p>{item.desc}</p>
                                    </div>
                                ))}
                            </div>
                            <p className="section-footer">
                                Chaque objet est unique, et mon expertise me permet d'identifier avec précision leur authenticité, leur histoire et leur valeur marchande.
                            </p>
                        </div>

                        <div className="section-block">
                            <h2>Services Offerts</h2>
                            <div className="cards-grid">
                                {services.map((service, index) => (
                                    <div key={index} className="feature-card service-card">
                                        <h3>{service.title}</h3>
                                        <p>{service.desc}</p>
                                    </div>
                                ))}
                            </div>
                            <p className="section-footer">
                                Avec une approche professionnelle et bienveillante, je m'assure que chaque client bénéficie d'une expérience transparente et sans stress.
                            </p>
                        </div>

                        <div className="section-block">
                            <h2>Pourquoi Nous Choisir ?</h2>
                            <div className="cards-grid">
                                {values.map((value, index) => (
                                    <div key={index} className="feature-card value-card">
                                        <h3>{value.title}</h3>
                                        <p>{value.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="cta-section">
                            <h2>Contactez-moi pour une Évaluation</h2>
                            <p>
                                Vous souhaitez vendre vos objets anciens, bijoux ou mobilier d'époque ? Je suis à votre disposition pour vous accompagner dans cette démarche.
                            </p>
                            <a href="/objets" className="cta-button">Quels objets rachetons-nous ?</a>
                        </div>
                    </div>

                </div>
            </div>

            <style jsx>{`
                .about-section {
                    padding: 80px 24px;
                    background: #fff;
                    position: relative;
                }

                .section-container {
                    max-width: 1400px;
                    margin: 0 auto;
                }

                .hero-header {
                    text-align: center;
                    margin-bottom: 80px;
                    padding: 60px 0;
                    background: linear-gradient(135deg, #f8fafb 0%, #f2f5f7 100%);
                    border-radius: 24px;
                    position: relative;
                    overflow: hidden;
                }

                .hero-header::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: radial-gradient(circle at 30% 70%, rgba(192, 162, 107, 0.1) 0%, transparent 50%);
                }

                .hero-content {
                    position: relative;
                    z-index: 2;
                }

                .hero-header h2 {
                    font-size: 3.5rem;
                    font-weight: 700;
                    color: #1f2b2a;
                    margin: 0 0 20px;
                    letter-spacing: -0.02em;
                    line-height: 1.1;
                    opacity: 0;
                    transform: translateY(30px);
                    transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
                }

                .animate-title {
                    opacity: 1 !important;
                    transform: translateY(0) !important;
                }

                .hero-subtitle {
                    font-size: 1.4rem;
                    color: #C0A26B;
                    margin: 0;
                    font-style: italic;
                    font-weight: 500;
                }

                .content-grid {
                    display: block;
                }

                .main-content {
                    display: flex;
                    flex-direction: column;
                    gap: 60px;
                }

                .intro-card {
                    background: linear-gradient(135deg, #fff 0%, #f8fafb 100%);
                    border-radius: 20px;
                    padding: 40px;
                    box-shadow: 0 8px 32px rgba(0,0,0,0.08);
                    border-left: 6px solid #C0A26B;
                }

                .intro-text {
                    font-size: 1.3rem;
                    line-height: 1.7;
                    color: #1f2b2a;
                    margin-bottom: 24px;
                }

                .intro-card p {
                    font-size: 1.1rem;
                    line-height: 1.7;
                    color: #44504f;
                    margin: 0 0 20px;
                }

                .intro-card p:last-child {
                    margin-bottom: 0;
                }

                .section-block {
                    background: #fff;
                    border-radius: 20px;
                    padding: 48px 40px;
                    box-shadow: 0 4px 24px rgba(0,0,0,0.06);
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                }

                .section-block:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 8px 40px rgba(0,0,0,0.1);
                }

                .section-block h2 {
                    font-size: 2.4rem;
                    color: #1f2b2a;
                    margin: 0 0 32px;
                    text-align: center;
                    position: relative;
                    font-weight: 600;
                }

                .section-block h2::after {
                    content: '';
                    position: absolute;
                    bottom: -8px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 60px;
                    height: 3px;
                    background: linear-gradient(90deg, transparent, #C0A26B, transparent);
                }

                .cards-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
                    gap: 24px;
                    margin-bottom: 32px;
                }

                .feature-card {
                    background: #f8fafb;
                    border-radius: 16px;
                    padding: 24px;
                    transition: all 0.3s ease;
                    position: relative;
                    overflow: hidden;
                }

                .feature-card::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    height: 4px;
                    background: linear-gradient(90deg, #C0A26B, #d4b875);
                    transform: scaleX(0);
                    transition: transform 0.3s ease;
                }

                .feature-card:hover::before {
                    transform: scaleX(1);
                }

                .feature-card:hover {
                    transform: translateY(-4px);
                    background: #fff;
                    box-shadow: 0 8px 24px rgba(0,0,0,0.1);
                }

                .expertise-card {
                    border-left: 4px solid #C0A26B;
                }

                .service-card {
                    border-left: 4px solid #20453d;
                }

                .value-card {
                    border-left: 4px solid #d4b875;
                }

                .feature-card h3 {
                    font-size: 1.25rem;
                    font-weight: 600;
                    color: #1f2b2a;
                    margin: 0 0 12px;
                }

                .feature-card p {
                    font-size: 1rem;
                    line-height: 1.6;
                    color: #44504f;
                    margin: 0;
                }

                .section-footer {
                    font-size: 1.1rem;
                    line-height: 1.7;
                    color: #44504f;
                    text-align: center;
                    font-style: italic;
                    margin: 0;
                    padding: 24px;
                    background: linear-gradient(135deg, #f8fafb 0%, #f2f5f7 100%);
                    border-radius: 12px;
                }

                .cta-section {
                    background: linear-gradient(135deg, #20453d 0%, #1a3a33 100%);
                    border-radius: 24px;
                    padding: 48px 40px;
                    text-align: center;
                    color: #fff;
                    position: relative;
                    overflow: hidden;
                }

                .cta-section::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: radial-gradient(circle at 70% 30%, rgba(192, 162, 107, 0.1) 0%, transparent 50%);
                }

                .cta-section > * {
                    position: relative;
                    z-index: 2;
                }

                .cta-section h2 {
                    color: #C0A26B;
                    margin-bottom: 20px;
                }

                .cta-section h2::after {
                    background: linear-gradient(90deg, transparent, #C0A26B, transparent);
                }

                .cta-section p {
                    font-size: 1.2rem;
                    line-height: 1.6;
                    color: rgba(255,255,255,0.9);
                    margin: 0 0 32px;
                    max-width: 600px;
                    margin-left: auto;
                    margin-right: auto;
                }


                .cta-button {
                    display: inline-block;
                    background: linear-gradient(135deg, #C0A26B 0%, #d4b875 100%);
                    color: #20453d;
                    padding: 18px 36px;
                    text-decoration: none;
                    border-radius: 30px;
                    font-weight: 700;
                    font-size: 1.1rem;
                    transition: all 0.4s ease;
                    box-shadow: 0 6px 24px rgba(192, 162, 107, 0.4);
                    position: relative;
                    overflow: hidden;
                }

                .cta-button::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: -100%;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
                    transition: left 0.6s ease;
                }

                .cta-button:hover::before {
                    left: 100%;
                }

                .cta-button:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 10px 32px rgba(192, 162, 107, 0.6);
                }


                @media (max-width: 768px) {
                    .about-section {
                        padding: 60px 20px;
                    }

                    .hero-header {
                        margin-bottom: 60px;
                        padding: 40px 24px;
                    }

                    .hero-header h2 {
                        font-size: 2.5rem;
                    }

                    .hero-subtitle {
                        font-size: 1.2rem;
                    }

                    .content-grid {
                        gap: 40px;
                    }

                    .main-content {
                        gap: 40px;
                    }

                    .intro-card,
                    .section-block,
                    .cta-section {
                        padding: 32px 24px;
                    }

                    .cards-grid {
                        grid-template-columns: 1fr;
                        gap: 16px;
                    }

                    .section-block h2 {
                        font-size: 2rem;
                    }

                }

                @media (max-width: 480px) {
                    .about-section {
                        padding: 40px 16px;
                    }

                    .hero-header {
                        padding: 32px 20px;
                        margin-bottom: 40px;
                    }

                    .hero-header h2 {
                        font-size: 2rem;
                        line-height: 1.2;
                    }

                    .hero-subtitle {
                        font-size: 1.1rem;
                    }

                    .intro-card,
                    .section-block,
                    .cta-section {
                        padding: 24px 20px;
                    }

                    .section-block h2 {
                        font-size: 1.8rem;
                    }

                    .feature-card {
                        padding: 20px;
                    }

                }
            `}</style>
        </section>
    );
}

export default AboutSection;
